// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.varStack {
    border: 1px solid lightgray;
    padding: 4px;
    margin-bottom: 4px;
}

.checkRow {
    justify-content: space-between
}

    .checkRow > * {
        align-self: center;
    }`, "",{"version":3,"sources":["webpack://./src/app/workflow/modules/variables/readGlobalVariable/readGlobalVariable.settings.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI;AACJ;;IAEI;QACI,kBAAkB;IACtB","sourcesContent":[".varStack {\n    border: 1px solid lightgray;\n    padding: 4px;\n    margin-bottom: 4px;\n}\n\n.checkRow {\n    justify-content: space-between\n}\n\n    .checkRow > * {\n        align-self: center;\n    }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
